module.exports = __webpack_public_path__ + "static/media/HoverIcon.f9525020.svg";